import { render, staticRenderFns } from "./ContentReferencesBlock.vue?vue&type=template&id=117d7d3a&scoped=true"
import script from "./ContentReferencesBlock.vue?vue&type=script&lang=js"
export * from "./ContentReferencesBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentReferencesBlock.vue?vue&type=style&index=0&id=117d7d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117d7d3a",
  null
  
)

export default component.exports